import React, { useEffect, useState } from 'react';
import CustomTabs from '../../../../common/Tabs';
import CustomDistanceMap from './customDistanceMap';
import PortDistance from './portDistance';

function DistanceMatrix({ setLoader, loader, setIsFullScreen }) {
  const [selectedMode, setSelectedMode] = useState('portLocations');

  useEffect(() => {
    if (setIsFullScreen) {
      setIsFullScreen(true);
    }
    return () => {
      if (setIsFullScreen) {
        setIsFullScreen(false);
      }
    };
  }, [setIsFullScreen]);

  const tabs = [
    { label: 'Enter Port Locations', key: 'portLocations' },
    { label: 'Select Custom Locations', key: 'route' },
  ];

  const topTabs = (
    <div className="h-[48px] px-3 bg-white border-b border-slate-200 flex items-center justify-between flex-shrink-0 z-20 w-full">
      <CustomTabs
        tabs={tabs}
        active={selectedMode}
        setActive={setSelectedMode}
      />
    </div>
  );

  return (
    <div className="w-full h-full flex-1 flex flex-row overflow-hidden bg-white">
      {selectedMode === 'portLocations' ? (
        <PortDistance setLoader={setLoader} loader={loader} setIsFullScreen={setIsFullScreen} topTabs={topTabs} />
      ) : (
        <CustomDistanceMap setLoader={setLoader} loader={loader} setIsFullScreen={setIsFullScreen} topTabs={topTabs} />
      )}
    </div>
  );
}

export default DistanceMatrix;